import type { User } from 'types/User';

import {
  getEntrypoint,
  getPreviousPagePath,
  getPreviousPageType,
  getSourceAndMedium
} from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  clientIp?: string;
  isBot: boolean;
  user: User;
};

class HomepageViewEvent extends UserEvent<EventData> {
  collectServerEvents() {
    this.serverEvents.push({
      data: {
        client_ip: this.data.clientIp,
        is_logged_in: this.data.user.isLoggedIn,
        useragent: navigator.userAgent,
        ...this.getSharedParams()
      },
      type: 'homepage_view'
    });
  }

  private getSharedParams() {
    return {
      entry_point: getEntrypoint(),
      page_path: window.location.pathname,
      page_type: 'homepage' as const,
      platform: 'web' as const,
      previous_page_path: getPreviousPagePath(),
      previous_page_type: getPreviousPageType(),
      source_medium: getSourceAndMedium()
    };
  }
}

export default HomepageViewEvent;
